import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import FileToUrl from '../../form/FileToUrl';
import FormTextArea from '../../form/FormTextArea';
import BasicFormInput from '../../form/BasicFormInput';
import { formatTopImage } from '../../form/utils';


// const client = new Twitter({
//   consumer_key: 'gUT7pPUO48WLwjbzSab932gEr',
//   consumer_secret: 'RJ2thrNt2y1ZJIDHzXIPJMm5dYpneWDOcEqedbEsjQfFgAQypL',
//   access_token_key: '885251996608978945-eu7hfkCeEgb37Bit1sv5U6fEfh5Ob9A',
//   access_token_secret: '9jcMGcRjZ9jXyRsENifaprzH6OG2dZKB0EwbQOwI4q87z',
// });
//

class TwitterField extends Component {
  render() {
    const { change, twitterImage } = this.props;
    return (
      <div className="publish-twitter">
        <div>
          <Field
            name="twitter_message"
            component={FormTextArea}
            label="Tweet"
          />
        </div>
        <div className="twitter-image clearfix">
          <div className="create-form-image-item clearfix">
            <Field
              label="Add Image"
              name="twitter_image_url"
              component={BasicFormInput}
              controlId="twitterImage"
              format={formatTopImage}
            />
            <FileToUrl onUrlChange={newUrl => change('twitter_image_url', newUrl)} />
            {formatTopImage(twitterImage) &&
              <img className="create-form-image-thumbnail" src={formatTopImage(twitterImage)} role="presentation" />
            }
          </div>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('generic-entry');
function mapStateToProps(state) {
  return {
    twitterImage: selector(state, 'twitter_image_url'),
  };
}

TwitterField.propTypes = {
  change: PropTypes.func,
  twitterImage: PropTypes.string,
};

export default connect(
  mapStateToProps,
)(TwitterField);



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/TwitterField.js